import Collection from './generic/collection'
import { Swiper, Navigation, Pagination } from 'swiper/swiper.esm.js'
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'
import { onAjaxContentLoaded } from './generic/evented'

Swiper.use([Navigation, Pagination]);

/**
 * Класс для коллекции слайдеров.
 * Элемент коллекции можно получить при помощи метода getByDOMElement
 */
export default class Sliders extends Collection {
    sliders = [
      {
        'selector': '.main-slider .swiper-container',
        'options': {
          slidesPerView: 1,
        }
      },
      {
        'selector': '.finish-ring-view__img-slider.swiper-container',
        'options': {
          slidesPerView: 1,
          spaceBetween: 12,
          pagination: {
            el: '.finish-ring-view__img-slider.swiper-container .swiper-pagination',
            clickable: true,
          },
          loop: true,
        }
      }
    ];

    constructor() {
      super();
      this.init();
      this.#bindEvents();
    }

    init() {
      this.sliders.forEach(slider => {
        const sliders = document.querySelectorAll(slider.selector);

        for (let sliderDOMElem of sliders) {
          const swiperSlider = new Slider(sliderDOMElem, slider.options);
          this.collection = swiperSlider;
        }
      });
    }

    #bindEvents() {
      onAjaxContentLoaded(() => {
        this.init()
      })
    }
}

export class Slider {
    instance;
    swiperInstance;

    /**
     *
     * @param sliderDOMElem{HTMLElement}
     * @param options{Object}
     * @return {Class}
     */
    constructor(sliderDOMElem, options) {
      this.instance = sliderDOMElem;
      this.swiperInstance = new Swiper(sliderDOMElem, options);
    }
}